module.exports = __webpack_public_path__ + "static/img/card0.6a0e339.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/card0.jpg
// module id = 6/6m
// module chunks = 1